const icon = require('vue-svgicon');
icon.register({
    'question': {
        width: 12,
        height: 12,
        viewBox: '0 0 12 12',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M.667 6a5.333 5.333 0 1010.667 0A5.333 5.333 0 00.667 6zm.711 0a4.622 4.622 0 119.245 0 4.622 4.622 0 01-9.245 0zm4.753.708a.6.6 0 00.252.466l-.59.263a1 1 0 01-.369-.797c0-.644.476-.978.93-1.296.416-.291.814-.57.814-1.061 0-.486-.378-.903-1.134-.903-.736 0-1.19.31-1.55.796L4 3.652c.465-.612 1.182-.99 2.102-.99C7.283 2.662 8 3.332 8 4.166c0 .812-.573 1.213-1.085 1.57-.412.288-.784.548-.784.972zm.404 2.087a.537.537 0 00-.533-.533.538.538 0 00-.533.533c0 .291.242.534.533.534.29 0 .533-.243.533-.534z" _fill="#9C9BA9"/>`,
    },
});
